/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as AppointmentActions from "../../store/Actions/Appointment";
import moment from "moment/moment";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../Helper/Firebase";
import { DB_COLLECTION } from "../../Constant/Constant";
import { useSnackbar } from "notistack";
import "react-datepicker/dist/react-datepicker.css";
import { convertTime12to24 } from "../../components/timeConvertor/convertTime12to24";
import NewAppointment from "../../components/Appointment/NewAppointment";
import "./Appointment.scss";

const Appointment = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // ON CHANGE
  const [selected, setSelected] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [date, setDate] = useState(null);
  const [tempDate, setTempDate] = useState(null);
  const [start_time, setStart_time] = useState("");
  // DATA GET FROM FIREBASE
  const [appointmentDate, setAppointmentDate] = useState([]);
  const [booked, setBooked] = useState([]);
  const [category, setCategory] = useState([]);
  const [timeslot, setTimeslot] = useState([]);
  // FOR VALIDATION MSG
  const [namemsg, setNamemsg] = useState(false);
  const [reasonmsg, setReasonmsg] = useState(false);
  const [datemsg, setDatemsg] = useState(false);
  const [timemsg, setTimemsg] = useState(false);
  const [numbermsg, setNumbermsg] = useState(false);
  // DISPLAY TIME SLOT
  const [displayTime, setDisplayTime] = useState([]);

  // FOR APPOINTMENT SUCCESS MSG
  const handleClickVariant = (variant) => {
    enqueueSnackbar("Appointment Booked Successfully", {
      variant,
      anchorOrigin: { horizontal: "center", vertical: "top" },
    });
  };

  useEffect(() => {
    (async () => {
      const a = await query(collection(db, DB_COLLECTION.TIME_SLOT));
      onSnapshot(a, (snapshot) => {
        let newTimeSlots = [];
        snapshot.docs.forEach((item) => {
          if (
            item.data()?.fullStartTime >= "2023-01-01T03:30:00.000Z" &&
            item.data()?.fullStartTime <= "2023-01-01T13:30:00.000Z"
          ) {
            newTimeSlots.push(item.data().start_time);
          }
        });
        setTimeslot(newTimeSlots);
      });
      const b = await query(collection(db, DB_COLLECTION.CATEGORY));
      onSnapshot(b, (snapshot) => {
        let allCategory = [];
        snapshot.docs.forEach((item) => {
          allCategory.push(item.data().name);
        });
        setCategory(allCategory);
      });
      const c = await query(collection(db, DB_COLLECTION.APPOINTMENT));
      onSnapshot(c, (snapshot) => {
        let bookedSlot = [];
        snapshot.docs.forEach((item) => {
          bookedSlot.push({
            date: item.data().date,
            time: item.data().start_time,
            timeSlots: item.data().occupiedTimeslots,
          });
        });
        setAppointmentDate(bookedSlot);
      });
    })();
  }, [date]);

  const filteredTime = [];

  useEffect(() => {
      const selectDateTime = appointmentDate.filter((item) => {
        return item.date == date;
      });
      selectDateTime?.map((item) => {
        item?.timeSlots?.map(ele => {
          return filteredTime.push(ele.start_time);
        })
      })
      const updatedTime = timeslot.filter((item) => !filteredTime.includes(item));
      updatedTime.sort(function (a, b) {
        return new Date("1970/01/01 " + a) - new Date("1970/01/01 " + b);
      });
   const arr = updatedTime?.filter(item => {
        if (item != "09:00 am" && item != "09:30 am" && item != "10:00 am") {
        return item
      }
    })
    setDisplayTime(arr);
  }, [tempDate]);
  
  const submitHandler = async () => {
    // if (selected !== "") {
      if (name.length <= 2) {
        setNamemsg(true);
      }
      if (mobile.length !== 10) {
        setNumbermsg(true);
      }
      if (date == null) {
        setDatemsg(true);
      }
      if (start_time === "") {
        setTimemsg(true);
      }
      if (
        name.length > 2 &&
        mobile.length === 10 &&
        date !== null &&
        start_time !== ""
      ) {
        Submit();
      }
    // } else {
    //   if (name.length < 3) {
    //     setNamemsg(true);
    //   }
    //   if (mobile.length < 10) {
    //     setNumbermsg(true);
    //   }
    //   if (date === null) {
    //     setDatemsg(true);
    //   }
    //   if (start_time === "") {
    //     setTimemsg(true);
    //   }
    //   // if (selected === "") {
    //   //   setReasonmsg(true);
    //   // }
    // }
  };

  function Submit() {
    setSelected("");
    setName("");
    setMobile("");
    setDate(null);
    setTempDate(null);
    setStart_time("");
    const appointmentData = {
      // reason: selected,
      name: name,
      mobile: mobile,
      date: date,
      start_time: start_time,
      isdeleted: false,
      status: "pending",
      create_at: moment().toISOString(),
    };
    dispatch(AppointmentActions.Appointment(appointmentData));
    handleClickVariant("success");
  }

  return (
    <>
      {/* APPOINTMENT FORM */}
      <NewAppointment
        name={name}
        setName={setName}
        setNamemsg={setNamemsg}
        namemsg={namemsg}
        mobile={mobile}
        setMobile={setMobile}
        setNumbermsg={setNumbermsg}
        numbermsg={numbermsg}
        tempDate={tempDate}
        setTempDate={setTempDate}
        setDate={setDate}
        setDatemsg={setDatemsg}
        datemsg={datemsg}
        start_time={start_time}
        setStart_time={setStart_time}
        setTimemsg={setTimemsg}
        displayTime={displayTime}
        timemsg={timemsg}
        selected={selected}
        setSelected={setSelected}
        setReasonmsg={setReasonmsg}
        category={category}
        reasonmsg={reasonmsg}
        submitHandler={submitHandler}
      />
    </>
  );
};

export default Appointment;
